import { render, staticRenderFns } from "./smartLockersService.vue?vue&type=template&id=55b1bc66&scoped=true&"
import script from "./smartLockersService.vue?vue&type=script&lang=js&"
export * from "./smartLockersService.vue?vue&type=script&lang=js&"
import style0 from "./smartLockersService.vue?vue&type=style&index=0&id=55b1bc66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b1bc66",
  null
  
)

export default component.exports